module.exports = __webpack_public_path__ + "static/csc-3-c2582ea0b985b77168ba49ff39e045bc.jpg";